import { ArtistGenreUnionType as ApiArtistGenreUnionType } from 'src/api/generated/touring/types';
import { ArtistGenreUnionType } from '../common/types';

export const mapArtistGenreType = (
  apiType: ApiArtistGenreUnionType
): ArtistGenreUnionType => {
  return apiType as ArtistGenreUnionType;
};
